import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import imagePlaceholder from '../../../../styles/img/img-placeholder.png'

export const UiAddImageInput = (props) => {
    const [inputImage, setInputImage] = useState('');  

    return (
        <>
            <div className="sb-add-image-card">
                <div className="sb-add-image-card__inner">
                    {
                        props.title && <h4>{props.title}</h4>
                    }

                    <Form.Group controlId="formFileLg" className="mb-3">
                        <Form.Control type="file" size="lg" onChange={(e) => setInputImage(e.target.value)} />
                        <img src={imagePlaceholder} />
                        {inputImage &&
                            <> <p>{inputImage}</p></>
                        }
                    </Form.Group>

                </div>
            </div>
        </>
    )
}